import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCompressImage = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 54 64"
    {...props}
  >
    <rect
      width={53}
      height={63}
      x={0.5}
      y={0.5}
      fill="#fff"
      stroke="#E5E6EB"
      rx={4.5}
    />
    <rect width={32} height={16} x={11} y={44} fill="#F4AC3F" rx={3} />
    <path
      fill="#fff"
      d="M20.075 56.588q-.803 0-1.408-.297a2.26 2.26 0 0 1-.935-.858q-.33-.55-.33-1.276v-.737q0-.055.033-.088a.14.14 0 0 1 .1-.044h1.011q.055 0 .088.044.044.033.044.088v.737q0 .594.374.968.386.363 1.023.363.616 0 1.012-.363.396-.374.396-.968v-5.225q0-.055.033-.088a.14.14 0 0 1 .1-.044h1q.055 0 .088.044.045.033.044.088v5.225q0 .727-.34 1.276-.33.55-.947.858-.604.297-1.386.297m7.37-7.799q.694 0 1.222.286.528.285.814.814.297.517.297 1.199 0 .67-.297 1.188t-.847.803q-.54.275-1.254.275h-1.76q-.055 0-.055.055v2.959q0 .056-.044.099a.12.12 0 0 1-.088.033H24.42a.16.16 0 0 1-.1-.033.16.16 0 0 1-.032-.099v-7.447q0-.055.033-.088a.14.14 0 0 1 .099-.044zm-.186 3.531q.56 0 .902-.33.34-.33.34-.869 0-.55-.34-.891-.341-.34-.902-.341h-1.64q-.054 0-.054.055v2.321q0 .055.055.055zm6.212 4.268q-.825 0-1.452-.319a2.35 2.35 0 0 1-.968-.924 2.7 2.7 0 0 1-.341-1.364v-2.662q0-.78.34-1.364.341-.594.969-.913.627-.33 1.452-.33.814 0 1.43.319.627.319.968.869t.34 1.243v.088q0 .056-.043.099a.12.12 0 0 1-.088.033h-1.001a.16.16 0 0 1-.1-.033.16.16 0 0 1-.032-.099v-.055a1.3 1.3 0 0 0-.407-.979q-.396-.385-1.067-.385-.672 0-1.078.407-.407.396-.407 1.056v2.75q0 .66.429 1.067.429.396 1.11.396.66 0 1.035-.341.385-.352.385-.957v-.682q0-.055-.055-.055h-1.353a.16.16 0 0 1-.1-.033.16.16 0 0 1-.032-.099v-.814q0-.055.033-.088a.14.14 0 0 1 .099-.044h2.54q.056 0 .089.044.044.033.044.088v1.408q0 1.265-.748 1.969-.737.705-1.991.704"
    />
    <path
      fill="#DCDDE6"
      fillRule="evenodd"
      d="M37.732 35.526c2.55.002 3.812.01 4.796-.48a4.5 4.5 0 0 0 1.978-1.921c.486-.942.478-2.194.494-4.67l-.026-12.364c-.003-2.48.003-3.71-.501-4.667a4.53 4.53 0 0 0-1.978-1.93c-.969-.474-2.25-.487-4.78-.483L16.245 9c-2.53.004-3.811-.009-4.77.466a4.5 4.5 0 0 0-1.984 1.94c-.506.937-.497 2.189-.489 4.65l.001 12.38c.008 2.461-.002 3.708.507 4.648a4.4 4.4 0 0 0 1.978 1.928c.963.494 2.25.488 4.799.49z"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M17.317 20.046c1.68-.004 3.037-1.323 3.024-2.939.012-1.63-1.345-2.952-3.025-2.948-1.675-.015-3.031 1.304-3.024 2.938s1.35 2.934 3.025 2.949"
      clipRule="evenodd"
    />
    <path
      fill="#9394A5"
      fillRule="evenodd"
      d="M44.506 33.125c.486-.942.478-2.194.494-4.67l-.007-1.634-8.015-7.802c-1.127-1.101-2.992-1.105-4.122-.01l-16.77 16.319 15.864.198h5.782c2.55.002 3.812.01 4.796-.48a4.5 4.5 0 0 0 1.978-1.921"
      clipRule="evenodd"
    />
    <path
      fill="#A9AABC"
      fillRule="evenodd"
      d="m16.287 35.502 15.663.024-10.777-10.5c-1.147-1.106-2.992-1.105-4.122-.01L9.28 32.56c.069.2.13.357.229.524a4.4 4.4 0 0 0 1.978 1.928c.963.494 2.25.488 4.799.49"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCompressImage;
